import React from 'react';
import emailjs from '@emailjs/browser';

const ContactForm = () => {
    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_atusiwf', 'template_17eepba', e.target, '_b88jeJQHtdgxd5qG')
            .then((result) => {
                console.log(result.text);
            }, (error) => {
                console.log(error.text);
            });
        e.target.reset();
    };

    return (
        <div>
            <h1 className='text-3xl font-bold text-center'>Contact Me</h1>
            <div className='mt-10 flex justify-center items-center '>
                <div className='w-96 p-7 border-2 border-neutral ' >
                    <h1 className='text-md font-semibold text-center'>Leave a message</h1>
                    <form onSubmit={sendEmail} >
                        <div className="form-control w-full max-w-xs">
                            <label className="label">
                                <span className="label-text">Name</span>
                            </label>
                            <input type="text" className="input border-2 border-black bg-white w-full max-w-xs" name='from_name' />
                        </div>

                        <div className="form-control w-full max-w-xs">
                            <label className="label">
                                <span className="label-text">Email</span>
                            </label>
                            <input type="email"

                                className="input border-2 border-black w-full max-w-xs bg-white" name='email_id' />

                            <label className="label">
                                <span className="label-text">Message</span>
                            </label>

                            <textarea className=" border-2 border-black bg-white mb-5" cols='30' rows='8' name='message' > </textarea>

                            <input className='button  text-black w-full text-sm' value='Send' type="submit" />
                        </div>


                        <div>

                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ContactForm;